// /about-us/ page controller. Two responsibilities, both scoped to the
// page root so this is a no-op on every other route:
//
//  1. Masthead "Our Story" letter-by-letter reveal on first paint.
//  2. Scroll-triggered reveal of [data-reveal] sections / figures /
//     headings / quote / closers via IntersectionObserver. One observer,
//     unobserves after firing.
//
// The global `[data-reveal]` base state lives in know-how-page.scss (which
// is part of the site bundle); we just need the JS that flips the class.
// Heading-char styles are page-scoped under .sentiments-about-us-page.

export function initAboutUsPage() {
	const root = document.querySelector('.sentiments-about-us-page');
	if (!root) return;

	initHeadingReveal(root);
	initScrollReveal(root);
}

function initHeadingReveal(root) {
	const heading = root.querySelector('.sentiments-about-us-page__heading');
	if (!heading) return;

	const text = heading.textContent.trim();
	if (!text) return;

	heading.textContent = '';
	Array.from(text).forEach((ch, i) => {
		const span = document.createElement('span');
		span.className = 'sentiments-about-us-page__heading-char';
		span.setAttribute('aria-hidden', 'true');
		span.style.setProperty('--char-delay', `${i * 55}ms`);
		span.textContent = ch === ' ' ? ' ' : ch;
		heading.appendChild(span);
	});

	requestAnimationFrame(() => {
		requestAnimationFrame(() => heading.classList.add('is-revealed'));
	});
}

function initScrollReveal(root) {
	const targets = root.querySelectorAll('[data-reveal]');
	if (!targets.length) return;

	if (typeof IntersectionObserver !== 'function') {
		targets.forEach((el) => el.classList.add('is-revealed'));
		return;
	}

	const io = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-revealed');
					io.unobserve(entry.target);
				}
			}
		},
		{ threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
	);

	targets.forEach((el) => io.observe(el));
}
